import React from "react";

/**
 * Renders the Controls component.
 *
 * @param {object} props - The component properties.
 * @param {string} props.name - The name for the component.
 * @param {boolean} props.activeNewIntegration - Flag indicating whether a new integration is active.
 * @param {function} props.refresh - Function to refresh the integration list.
 * @param {function} props.setActiveNewIntegration - Function to update the active new integration state.
 * @returns {JSX.Element} The rendered Controls component.
 */
export default function Controls({
  name,
}: {
  name: string;
  activeNewIntegration: boolean;
  setActiveNewIntegration: (activeNewIntegration: boolean) => void;
}) {
  return (
    <div className="app" id={name}>
      <div className="controls">
        <div className="icon"> </div>
        <div className="title">
          <h1>{name}</h1>
        </div>
      </div>
    </div>
  );
}
